import React from 'react'
import { Button, CardGroup, Card} from 'react-bootstrap'


const Cardio = () => {
  return (

    <>
    <br/>
    <div className="d-grid gap-3">
          <Button style={{height:'70px'}} variant="secondary" size="lg"> Videos for train Cardio</Button>
        </div>
    
        <CardGroup>
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="cardio1.mp4" type="video/mp4" />
                    </video>
                </div>
                    <Card.Title style={{textAlign:'center'}}>Cardio workout at home</Card.Title>
                    {/* <Card.Text>
                    In this video I take you 7 different bicep exercises you can do to get bigger arms! 
                    These are CRUCIAL exercises to add to your arm day arsenal to grow your biceps.
                    </Card.Text>  */}
                </Card>
    
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%"
                        // autoPlay="false" 
                        controls>
                        <source src="cardio2.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Cardio workout at gym</Card.Title>
                </Card>
        </CardGroup>
    
    
        <CardGroup>
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="cardio3.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Cardio VS Strength trainings </Card.Title>
                </Card>
    
                <Card style={{margin:'25px'}}>
                <div>
                    <video 
                        style={{objectFit:'center'}} 
                        width="100%" 
                        height="100%" 
                        // autoPlay="false" 
                        controls>
                        <source src="cardio4.mp4" type="video/mp4" />
                    </video>
                </div>
                <Card.Title style={{textAlign:'center'}}>Cardio workout for begginers</Card.Title>
                </Card>
        </CardGroup>
    
    </>

    )
}

export default Cardio